export default {
  props: {
    title: {
      type: String,
    },
    sessions: {
      type: Array,
      required: true,
    },
  },

  components: {
    hotCardSolutions: () => import('~/components/Molecules/CardSolutions/CardSolutions.vue'),
  },
}
